import { FilterKey } from '../providers/FiltersProvider';
import { defaultPaginationInfo, defaultSortingInfo, usePaginationRequestInfo } from '../providers/PaginationRequestProvider';
import { useUpBreakpoints } from '../providers/BreakpointsProvider';

export function usePaginationRequestInput(activeFilterName?: FilterKey, pageName?: string, defaultSorting = defaultSortingInfo) {
  const { sortingInfo, requestQuery, paginationInfo } = usePaginationRequestInfo(activeFilterName, pageName);
  const { md } = useUpBreakpoints();
  const isMobile = !md;

  if (isMobile) {
    return {
      sortingInfo: defaultSorting,
      requestQuery: { selectedAccounts: requestQuery?.selectedAccounts || [] },
      paginationInfo: paginationInfo ? paginationInfo : defaultPaginationInfo
    };
  }

  if (activeFilterName) {
    return {
      sortingInfo,
      requestQuery,
      paginationInfo
    };
  }

  return {
    sortingInfo: defaultSorting,
    requestQuery: {},
    paginationInfo: defaultPaginationInfo
  };
}
